/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from '@angular/common';
import { IValidator } from '../_common/component/IValidator';
import { FinalReviewComponent} from './final_review.component';

export class FinalReviewValidation extends IValidator {

       constructor(private component: FinalReviewComponent,private menuID:number) {
             super();

             this.viewportScroller      = this.component.viewportScroller;
             this.birthCertifyConsentBK = this.component.eligibility.birthCertifyConsent;
             this.chkAgreeToLastNameBK  = this.component.eligibility.chkAgreeToLastName;
             this.chkReadDisclosureBK   = this.component.eligibility.chkReadDisclosure;
       }

       private success: boolean;
       private viewportScroller:ViewportScroller;

       private birthCertifyConsentBK:string;
       private chkAgreeToLastNameBK:string;
       private chkReadDisclosureBK:string;

       public validate(): boolean {

          this.success = true;

          if(this.component.eligibility.birthCertifyConsent != 'Y'){
               this.focus('birthRegConsent','chkbox_birthCertifyCheckbox').error_invalidBirthCertify = "final_review.error_invalidBirthCertify";
          }
          
          if((this.component.aboutChild.isParentAgreeOnLastName == 'Y' || 
               this.component.aboutChild.isParentAgreeOnSingleName == 'Y') 
               && this.component.eligibility.chkAgreeToLastName != 'Y'){
               this.focus('certifyChild','chkbox_agreeToLastNameCheckbox').error_invalidLastNameCertify = "final_review.error_invalidLastNameCertify";
          }
          
          if(this.component.eligibility.chkReadDisclosure != 'Y'){
               this.focus('collectionNotice','chkbox_collectionNoticeCheckbox').error_notice = "final_review.error_notice";
          }

          return this.success;

       }

       private focus(tagId:string,ctrlId:string) : FinalReviewComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

       public IdOfChanged():number { 

            if ( this.birthCertifyConsentBK != this.component.eligibility.birthCertifyConsent ||
                 this.chkAgreeToLastNameBK != this.component.eligibility.chkAgreeToLastName ||
                 this.chkReadDisclosureBK != this.component.eligibility.chkReadDisclosure ) return this.menuID;

            return 0;
       }
}

